import { useEffect, useState } from 'react';
import { basket } from '../utils/basketStore';

// "רשימות קודמות" (BasketTab → הוספה מהירה): כל רשימה שרוקנה נשמרת (spClearShoppingList).
// history = { archives, itemsByArchive } מ-spGetShoppingListHistory (BasketTab טוען). "הוספה לרשימה" — הכמויות מתווספות.

const pad = (n) => String(n).padStart(2, '0');
const formatDate = (value) => {
  const d = new Date(value);
  return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
const formatQty = (x) => (x.isWeighable ? `${Number(x.qty)} ק"ג` : `×${Number(x.qty)}`);
const PREVIEW = 6;

const s = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '5vh 12px', zIndex: 120 },
  dialog:  { width: '100%', maxWidth: 640, maxHeight: '90vh', display: 'flex', flexDirection: 'column', background: '#f4f5f7', borderRadius: 14, boxShadow: '0 16px 48px rgba(0,0,0,.25)', overflow: 'hidden' },
  header:  { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, background: '#fff', padding: '16px 18px', borderBottom: '1px solid #e5e7eb' },
  title:   { margin: 0, fontSize: 20, fontWeight: 700 },
  sub:     { margin: '2px 0 0', fontSize: 13, color: '#59636e' },
  close:   { background: 'none', border: 'none', fontSize: 26, lineHeight: 1, color: '#59636e' },
  body:    { overflowY: 'auto', padding: 14, display: 'flex', flexDirection: 'column', gap: 10 },
  card:    { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 14 },
  cardHead:{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap' },
  date:    { fontWeight: 700 },
  meta:    { fontSize: 13, color: '#59636e' },
  names:   { margin: '8px 0 0', fontSize: 14, color: '#1f2328', lineHeight: 1.7 },
  toggle:  { background: 'none', border: 'none', padding: 0, color: '#1a3f9c', fontSize: 13, fontWeight: 600 },
  add:     { padding: '7px 14px', fontSize: 14, fontWeight: 600, border: 'none', borderRadius: 10, background: '#1a3f9c', color: '#fff', whiteSpace: 'nowrap' },
  done:    { padding: '7px 14px', fontSize: 14, fontWeight: 600, border: '1px solid #2da44e', borderRadius: 10, background: '#effaf2', color: '#1a7f37', whiteSpace: 'nowrap' },
  empty:   { textAlign: 'center', color: '#59636e', padding: '32px 16px', lineHeight: 1.7 },
};

const ListHistoryDialog = ({ history, onClose }) => {
  const [expanded, setExpanded] = useState({});
  const [added, setAdded] = useState({});      // archiveId → הודעה אחרי הוספה
  const [busy, setBusy] = useState(null);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => { document.body.style.overflow = prev; document.removeEventListener('keydown', onKey); };
  }, [onClose]);

  const addAll = async (id) => {
    setBusy(id);
    const count = await basket.addArchive(id);
    setBusy(null);
    if (count !== null) setAdded({ ...added, [id]: count ? `✓ נוספו ${count} מוצרים חדשים` : '✓ הכמויות עודכנו' });
  };

  const archives = history?.archives || [];

  return (
    <div style={s.overlay} onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={s.dialog} role="dialog" aria-modal="true" aria-labelledby="history-title">
        <div style={s.header}>
          <div>
            <h2 id="history-title" style={s.title}>🕘 רשימות קודמות</h2>
            <p style={s.sub}>כל רשימה שסיימתם נשמרת כאן. הוספה — כל המוצרים בלחיצה אחת</p>
          </div>
          <button type="button" style={s.close} onClick={onClose} aria-label="סגירה">×</button>
        </div>
        <div style={s.body}>
          {!archives.length && (
            <div style={s.empty}>עוד אין רשימות קודמות.<br />כשמסיימים לקנות לוחצים "✅ סיימתי — ריקון הרשימה", והרשימה נשמרת כאן.</div>
          )}
          {archives.map((a) => {
            const list = history.itemsByArchive[a.id] || [];
            const open = expanded[a.id];
            const shown = open ? list : list.slice(0, PREVIEW);
            return (
              <div key={a.id} style={s.card}>
                <div style={s.cardHead}>
                  <div>
                    <div style={s.date} className="num">{formatDate(a.iTime)}</div>
                    <div style={s.meta}>{a.itemCount} מוצרים{a.archivedByName ? ` · נשמרה ע"י ${a.archivedByName}` : ''}</div>
                  </div>
                  {added[a.id]
                    ? <span style={s.done}>{added[a.id]}</span>
                    : <button type="button" style={s.add} onClick={() => addAll(a.id)} disabled={busy === a.id}>
                        {busy === a.id ? 'מוסיף…' : 'הוספה לרשימה'}
                      </button>}
                </div>
                <p style={s.names}>
                  {shown.map((x) => `${x.name || `מוצר ${x.itemId}`} ${formatQty(x)}`).join(' · ')}
                  {list.length > PREVIEW && (
                    <> {' '}<button type="button" style={s.toggle} onClick={() => setExpanded({ ...expanded, [a.id]: !open })}>
                      {open ? 'פחות' : `ועוד ${list.length - PREVIEW}…`}
                    </button></>
                  )}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ListHistoryDialog;
